<div class="d-flex flex-column w-100 w-sm-60 mx-auto">
    <div class="d-flex flex-column w-100 py-5">
        <div class="d-flex flex-column mx-auto mt-4ee p-2e">
            <img class="mx-auto my-2 rounded-circle" src="assets/images/sign-out-animation.gif" alt="Sign-out Animation">
            <p class="mx-auto mb-auto mat-headline-5 fw-bold">Logging you out...</p>
        </div>
    </div>
</div>
